import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

export function LegalFooter({ className = "" }: { className?: string }) {
  const { t } = useTranslation("legal");
  return (
    <footer
      className={`relative z-10 mx-auto flex w-full max-w-6xl flex-wrap items-center justify-center gap-4 px-6 py-6 text-xs text-muted-foreground ${className}`}
    >
      <Link to="/how-to-play" className="hover:text-foreground hover:underline">
        Anleitung
      </Link>
      <span aria-hidden>·</span>
      <Link to="/faq" className="hover:text-foreground hover:underline">
        FAQ
      </Link>
      <span aria-hidden>·</span>
      <Link to="/pricing" className="hover:text-foreground hover:underline">
        {t("footer.pricing")}
      </Link>
      <span aria-hidden>·</span>
      <Link to="/impressum" className="hover:text-foreground hover:underline">
        {t("footer.imprint")}
      </Link>
      <span aria-hidden>·</span>
      <Link to="/agb" className="hover:text-foreground hover:underline">
        {t("footer.terms")}
      </Link>
      <span aria-hidden>·</span>
      <Link to="/widerruf" className="hover:text-foreground hover:underline">
        {t("footer.refund")}
      </Link>
      <span aria-hidden>·</span>
      <Link to="/datenschutz" className="hover:text-foreground hover:underline">
        {t("footer.privacy")}
      </Link>
      <span aria-hidden>·</span>
      <LanguageSwitcher variant="ghost" size="sm" />
    </footer>
  );
}
